<template>
    <vx-card title="EPG" id="epgTimeline" class="vs-con-loading__container">
        <div class="w-full">
            <div class="float-left mr-3">
                <p>Start time</p>
                <flat-pickr :config="configDateTimePicker" v-model="startTime"/>
            </div>
            <div class="float-left mr-3">
                <p>End time</p>
                <flat-pickr :config="configDateTimePicker" v-model="endTime"/>
            </div>
        </div>
        <div style="clear: both"></div>
        <div class="mt-5 w-full">
            <vs-button @click="loadData" class="mr-3 mb-3">Refresh</vs-button>
            <vs-button @click="removeEPGEntries" color="danger">Remove EPG Data</vs-button>
        </div>
        <vs-divider/>
        <div :key="entry.id" v-for="entry in entries" class="vx-row">
            <div class="vx-col xl:w-2/12 md:w-1/4 w-full">
                <img v-if="entry.icon.length > 0" :src="entry.icon" style="max-width: 100%; max-height: 150px"/>
            </div>
            <div class="vx-col xl:w-10/12 md:w-3/4 md:mt-0 mt-3 w-full">
                <div class="w-full">
                    <h5 class="mb-3 float-left">{{moment(entry.start_time).format('YYYY/MM/DD HH:mm')}} - {{moment(entry.end_time).format('YYYY/MM/DD HH:mm')}}</h5>
                    <vs-chip color="primary" class="float-right ml-3" v-if="entry.timeshift_status === 0 && entry.timeshift_entry_id > 0">Recording entry created</vs-chip>
                    <vs-chip color="primary" class="float-right ml-3" v-if="entry.timeshift_status === 1">Recorder started</vs-chip>
                    <vs-chip color="warning" class="float-right ml-3 cursor-pointer" v-if="entry.timeshift_status === 2" @click.native="getTimeshiftLink(entry.timeshift_entry_id)">Recording</vs-chip>
                    <vs-chip color="success" class="float-right ml-3 cursor-pointer" v-if="entry.timeshift_status === 3" @click.native="getTimeshiftLink(entry.timeshift_entry_id)">Recorded</vs-chip>
                    <vs-chip color="danger" class="float-right ml-3" v-if="entry.timeshift_status === 4">Recorder crashed</vs-chip>
                </div>
                <div style="clear: both">

                </div>

                <h4>{{entry.title}} </h4>
                <p>{{entry.description}}</p>
            </div>
            <vs-divider/>
        </div>
    </vx-card>
</template>
<script>

    import flatPickr from 'vue-flatpickr-component'
    import 'flatpickr/dist/flatpickr.css'

    export default {
        components: {
            flatPickr
        },
        props: {
            channelId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {

                startTime: null,
                endTime: null,
                entries: [],

                configDateTimePicker: {
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    locale: {
                        firstDayOfWeek: 1
                    }
                }

            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#epgTimeline',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/channel/' + this.channelId + '/epg?start_time=' + this.moment(this.startTime).format('X') + '&end_time=' + this.moment(this.endTime).format('X'))
                loadPromise.then(function(response) {
                    thisIns.entries = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#epgTimeline > .con-vs-loading')
                })
            },
            removeEPGEntries() {
                this.$vs.loading({
                    container: '#epgTimeline',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.delete('/api/management/v1/channel/' + this.channelId + '/epg')
                loadPromise.then(function() {
                    thisIns.loadData()
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#epgTimeline > .con-vs-loading')
                })
            },
            getTimeshiftLink(entryId) {
                this.$vs.loading({
                    container: '#epgTimeline',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const reqPromise = this.$http.get('/api/management/v1/timeshift_entry/' + entryId + '/link')
                reqPromise.then(function(response) {
                    const newLink = response.data
                    thisIns.$copyText(response.data).then(function() {
                        thisIns.$printSuccess('Link copied to clipboard')
                    }, function() {
                        alert(newLink)
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#epgTimeline > .con-vs-loading')
                })
            }
        },
        watch: {
            channelId() {
                this.loadData()
            }
        },
        created() {
            this.startTime = new Date()
            this.startTime.setHours(0, 0, 0, 0)

            this.endTime = new Date()
            this.endTime.setHours(23, 59, 59, 999)
        },
        mounted() {
            this.loadData()
        }
    }

</script>
